import React from 'react'

const FresherIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.183 21.525C10.283 20.875 9.32067 20.35 8.29601 19.95C7.27067 19.55 6.19967 19.275 5.08301 19.125C4.58301 19.0583 4.16634 18.8457 3.83301 18.487C3.49967 18.129 3.33301 17.7167 3.33301 17.25V10.2C3.33301 9.56667 3.54967 9.04567 3.98301 8.637C4.41634 8.229 4.92467 8.075 5.50801 8.175C6.79134 8.39167 8.01234 8.78333 9.17101 9.35C10.329 9.91667 11.383 10.65 12.333 11.55C13.283 10.65 14.3373 9.91667 15.496 9.35C16.654 8.78333 17.8747 8.39167 19.158 8.175C19.7413 8.075 20.2497 8.229 20.683 8.637C21.1163 9.04567 21.333 9.56667 21.333 10.2V17.25C21.333 17.7167 21.1663 18.129 20.833 18.487C20.4997 18.8457 20.083 19.0583 19.583 19.125C18.4663 19.275 17.3957 19.55 16.371 19.95C15.3457 20.35 14.383 20.875 13.483 21.525C13.1497 21.775 12.7663 21.9 12.333 21.9C11.8997 21.9 11.5163 21.775 11.183 21.525ZM12.333 9C11.233 9 10.2913 8.60833 9.50801 7.825C8.72467 7.04167 8.33301 6.1 8.33301 5C8.33301 3.9 8.72467 2.95833 9.50801 2.175C10.2913 1.39167 11.233 1 12.333 1C13.433 1 14.3747 1.39167 15.158 2.175C15.9413 2.95833 16.333 3.9 16.333 5C16.333 6.1 15.9413 7.04167 15.158 7.825C14.3747 8.60833 13.433 9 12.333 9Z"
        fill="#3249D7"
      />
    </svg>
  )
}
export default FresherIcon
